import { BtmReturnInspectionProduct, BtmReturnInspectionStatus } from "../model/btm-return-inspection-product";
import React, { Fragment, useEffect, useState } from "react";
import { Checkbox, TableBody, TableCell, TableRow } from "@mui/material";
import { BtmReturnInspectionButton } from "../btm-request-details/btm-return-inspection-button";
import { AddTask, Cancel } from "@mui/icons-material";
import { IBaseBtmReturnRequestDeliveryOrderProductDto } from "../model/btm-return-request";
import { IUploadedFileDto } from "../../../../common/model/file-exchange-dto";
import { BtmFailedInspectionDialog } from "../btm-failed-inspection-dialog/btm-failed-inspection-dialog";

export const BtmRequestOrderedProductsInspection = (
    { detailList, onPresentProductsListChange }: {
        detailList: IBaseBtmReturnRequestDeliveryOrderProductDto[],
        onPresentProductsListChange: (products: BtmReturnInspectionProduct[]) => void,
    }) => {
    const [orderedProducts, setOrderedProducts] = useState<BtmReturnInspectionProduct[]>(
        detailList.flatMap(BtmReturnInspectionProduct.fromDeliveryOrderDetail));
    const [presentProducts, setPresentProducts] = useState<boolean[]>(Array(orderedProducts.length).fill(false));
    const handlePresentProductChange = (index: number, isPresent: boolean) => {
        setPresentProducts(prev => [...prev].map((item, i) => i === index ? isPresent : item));
    };

    const handleOrderedProductInspection = (index: number, inspectionResult: BtmReturnInspectionStatus,
                                            comment?: string, files?: IUploadedFileDto[]) => {
        setOrderedProducts(prev => prev.map((e, i) =>
            i === index ? e.inspect(inspectionResult, comment, files) : e));
    };

    useEffect(() => {
        onPresentProductsListChange(presentProducts.flatMap((value, index) => value ? [index] : [])
            .map(index => orderedProducts[index]));
    }, [orderedProducts, presentProducts]);

    return <TableBody>
        {orderedProducts.map((line, index) =>
            <BtmRequestOrderedProductInspection index={index} data={line}
                                                isPresent={presentProducts[index]}
                                                onPresentProductsListChange={isPresent =>
                                                    handlePresentProductChange(index, isPresent)}
                                                onInspectionCompleted={handleOrderedProductInspection} />)}
    </TableBody>;
};

const BtmRequestOrderedProductInspection = (
    { data, index, isPresent, onPresentProductsListChange, onInspectionCompleted }: {
        data: BtmReturnInspectionProduct,
        index: number,
        isPresent: boolean,
        onPresentProductsListChange: (isPresent: boolean) => void,
        onInspectionCompleted: (index: number, inspectionResult: BtmReturnInspectionStatus,
                                comment?: string, files?: IUploadedFileDto[]) => void,
    }) => {
    const [isFailedInspectionDialogOpen, setIsFailedInspectionDialogOpen] = useState(false);
    const [failedInspectionDialogStatus, setFailedInspectionDialogStatus] = useState<BtmReturnInspectionStatus>(BtmReturnInspectionStatus.None);

    const handleInspectionDetailsDialogOpen = (status: BtmReturnInspectionStatus) => {
        setIsFailedInspectionDialogOpen(true);
        setFailedInspectionDialogStatus(status);
    };

    const handleFailedInspectionComplete = (comment: string, files: IUploadedFileDto[]) => {
        onInspectionCompleted(index, failedInspectionDialogStatus, comment, files);
        setIsFailedInspectionDialogOpen(false);
    };

    return <Fragment>
        {isFailedInspectionDialogOpen &&
            <BtmFailedInspectionDialog data={data} status={failedInspectionDialogStatus}
                                       onComplete={handleFailedInspectionComplete}
                                       onClose={() => setIsFailedInspectionDialogOpen(false)} />}
        <TableRow key={`${data.barcode}-${index}`}>
            <TableCell>{data.productName}</TableCell>
            <TableCell>
                <Checkbox checked={isPresent} onChange={(_, checked) =>
                    onPresentProductsListChange(checked)} />
            </TableCell>
            <TableCell>{data.productId}</TableCell>
            <TableCell>X 1</TableCell>
            <TableCell>
                <BtmReturnInspectionButton color={"success"} isDisabled={!isPresent}
                                           isSelected={data.status === BtmReturnInspectionStatus.Accepted}
                                           onClick={() =>
                                               onInspectionCompleted(index, BtmReturnInspectionStatus.Accepted)}>
                    <AddTask />
                </BtmReturnInspectionButton>
                <BtmReturnInspectionButton color={"error"} isDisabled={!isPresent}
                                           isSelected={data.status === BtmReturnInspectionStatus.Refused}
                                           onClick={() => handleInspectionDetailsDialogOpen(BtmReturnInspectionStatus.Refused)}>
                    <Cancel />
                </BtmReturnInspectionButton>
            </TableCell>
        </TableRow>
    </Fragment>;
};
